// extracted by mini-css-extract-plugin
export default {"container":"Block_container__GKGz6"};